import { useInfiniteQuery } from "@tanstack/react-query";
const { default: apiClient } = require("lib/api-client");

const fetchArchiveSets = async ({ pageParam = 1, queryKey }) => {
  const [, { limit, sortBy, order, searchTerm, diamondPieces, diamondWeight, goldGrossWeight, goldNetWeight, designQuantity, collectionName, categoriesName , isHidden}] = queryKey;

  const response = await apiClient.post("/api/v1/set/getAllArchiveSets", {
    pageNumber: pageParam,
    limit,
    sortBy,
    order,
    searchTerm,
    diamondPieces: JSON.stringify(diamondPieces || []),
    diamondWeight: diamondWeight?.length > 0 ? diamondWeight : "",
    goldGrossWeight: goldGrossWeight?.length > 0 ? goldGrossWeight : "",
    goldNetWeight: goldNetWeight?.length > 0 ? goldNetWeight : "",
    designQuantity,
    collectionName,
    categoriesName,
    isHidden,
  });

  if (response.status !== 200) {
    throw new Error("Error fetching categories");
  }

  return {
    sets: response.data.sets,
    nextPage: response.data.pagination.pageNumber + 1,
    totalPages: response.data.pagination.totalPages,
  };
};

export const useArchivesSets = ({ limit = 10, sortBy, order, searchTerm, diamondPieces, diamondWeight, goldGrossWeight, goldNetWeight, designQuantity, collectionName, categoriesName , isHidden = true, allowRefetch = false}) => {
  return useInfiniteQuery({
    queryKey: ["archives-sets", { limit, sortBy, order, searchTerm, diamondPieces, diamondWeight, goldGrossWeight, goldNetWeight, designQuantity, collectionName, categoriesName , isHidden}],
    queryFn: ({ pageParam = 1 }) => fetchArchiveSets({ pageParam, queryKey: ["archives-sets", { limit, sortBy, order, searchTerm, diamondPieces, diamondWeight, goldGrossWeight, goldNetWeight, designQuantity, collectionName, categoriesName,isHidden }] }),
    getNextPageParam: (lastPage) => {
      if (lastPage.nextPage <= lastPage.totalPages) {
        return lastPage.nextPage;
      }
      return undefined;
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
    enabled: allowRefetch,
  });
};
